module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAATRJREFUaIHt1rErqFEcxvHvF0k3Ed1bBoOiiCQlGVzFYmJhkY3NKJPRJKNMJjaThYHFYJCbUqLrzzkG70Chl3uOu/w+4/ue8/yeTr2dF0IIIYQQQgihjB/ASskBTQWzW9WTasZgSmmjxJCGEqFAu3qWUjpIKU0BbeoeYKF5WXWq18DSi2equ+o+5Q4ti1/qDbDw1kt1Rz0EGr+3Vj1d6i0w99EidUs9ouz392nd6h0wW3P9pnoMNBfsVFuPeg/MfHLfunoKtBToVFuf+gD8/uL+NfWc5/vi2w2of4GJf8xZVS+A1gydahtWH4GxTHnL6iXQninvQ6NV+ZHMuYvqFdCROfeV8ar8UKH8efUP8LNE+GRVvr9E+Auz1WXYlTVV3QZ6s4a+b5rCf7EhhBBCCCGE8N89AaYiKPNwdToxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.png
// module id = 846
// module chunks = 1 3